import { z } from 'zod';
import { USER_STATUS } from '../constants/enums.js';
import { PaginationQuerySchema } from './common.js';

/**
 * Schemas for user CRUD and profile updates.
 */

export const UpdateProfileSchema = z.object({
  nickname: z.string().min(1).max(32).optional(),
  avatar: z.string().url().max(512).optional(),
  email: z.string().email().max(128).optional(),
  phone: z.string().min(7).max(20).optional(),
});
export type UpdateProfileRequest = z.infer<typeof UpdateProfileSchema>;

/**
 * Admin → platform-users list query. Extends pagination with user-specific
 * filters. Renamed from `AdminUserListQuerySchema` to disambiguate from the
 * RBAC admin-staff list schema in `admin.ts` (which owns that name).
 */
export const PlatformUserListQuerySchema = PaginationQuerySchema.extend({
  keyword: z.string().max(64).optional(),
  status: z.nativeEnum(USER_STATUS).optional(),
  level: z
    .string()
    .regex(/^v\d$/)
    .optional(),
  referrer_id: z.coerce.number().int().positive().optional(),
});
export type PlatformUserListQuery = z.infer<typeof PlatformUserListQuerySchema>;

/** Admin → edit user. All fields optional — this is a PATCH. */
export const AdminEditUserSchema = z.object({
  nickname: z.string().max(32).optional(),
  email: z.string().email().max(128).optional().nullable(),
  phone: z.string().max(20).optional().nullable(),
  status: z.nativeEnum(USER_STATUS).optional(),
  level: z
    .string()
    .regex(/^v\d$/)
    .optional(),
  note: z.string().max(500).optional().nullable(),
  frozen_reason: z.string().max(500).optional().nullable(),
});
export type AdminEditUserRequest = z.infer<typeof AdminEditUserSchema>;
